
import Header from '../header';
 

 
  
export default function Landingpage() {
    
  
    return <>

        <section className="title">

            <div className="container-fluid">
                {/* <!-- navba expand is used to make the bav item to place itself orizontally on the larg screen and vertically on small screen --> */}
                 <Header/>
                <div className="row">
                    <div className="col-lg-6">
                        <h1 className="headlines"> All dogs are pawsome. Walking with them is pride, taking care of them is
                            beautiful. Give Your dogs quality care </h1>
                        <p className="parag">We are the pawfect fur sitters</p>
                        <a  href = "mailto: ispeakfordogs@yahoo.com? subject = Feedback&body = Message" className="btn  btn-danger btn-lg Download" type="button"> <i className=" far fa-envelope "> </i> Contact
                            Us</a> 
                        <a href="https://www.instagram.com/posh_mo/" className="btn btn-outline-light  btn-lg Download" type="button"> <i className=" fab fa-instagram "> </i> Contact
                         Us</a>
                    </div>
                    <div className="col-lg-6">
                        <img className="titleimage" src="images/rado5c.jpg" alt="iphone-mockup" />
                    </div>
                </div>
            </div>
        </section>


        {/* <!-- Features --> */}

        <section id="features">
            <div className="row">

                <div className="feature-box  col-lg-4">

                    <img className="pawp" src="images/pawpalz.png" alt="" />
                    <i className="fas fa-heart fa-4x icon"></i>
                    <h3 className='feature-text'>Boarding</h3>
                    <p> Keep your beloved dogs happy and safe, while you are away and they need a home for sleepover stay,
                        PM Paws is home away from home </p>
                    <a href="/boarding" className="btn btn-outline-light btn-lg service" type="button"><i className="far fa-paw"></i> Learn more </a>
                </div>

                <div className="feature-box col-lg-4">
                    <img className="pawp" src="images/pawpalz.png" alt="" />
                    <i className="fas fa-spa  fa-4x icon"></i>
                    <h3 className='feature-text'>Spa </h3>
                    <p>Our spa services offer numerous grooming packages including bathing, drying, brushing, ear cleaning,
                        gland expression, sanitary trim and breed-specific haircuts and more</p>
                    <a href="/daycare" className="btn btn-outline-light btn-lg service" type="button"><i className="far fa-paw"></i> Learn more
                    </a>
                </div>
                <div className="feature-box col-lg-4    ">
                    <img className="pawp" src="images/pawpalz.png" alt="" />
                    <i className="far fa-hand-heart  fa-4x icon"></i>
                    <h3 className='feature-text'>DayCare</h3>
                    <p>We provide care for our children, why cant we do so for our dogs? at PMPaws we provide recurring
                        daycare, safe socialization, education,exercise and more.</p>
                    <a href="/daycare" className="btn btn-outline-light btn-lg service" type="button"><i className="far fa-paw"></i> Learn more
                    </a>
                </div>
            </div>

        </section>


        {/* <!-- Testimonials --> */}

<section id="testimonials">
  
     
 
            <div className="container-fluid">

                <div className="row">
                    
                    <div className="col-lg-3 col-sm-6">
                        <img className="testimonial-image" src="images/star.JPG" alt="dog-profile"/>
<p className='text-white test-p p-3  '>
                       What i  do on my day off? Can't lie around, you know i have to work and that's my job </p>
                    </div>
                
          
                    <div className="col-lg-3 col-sm-6">
                        <img className="testimonial-image" src="images/shaniandjake.JPG" alt="dog-profile"/>
                        <p className='text-white test-p p-3  '>
                        I no longer have to sniff other dogs for love. I've found the hottest friends on PmPaws.
                             </p>
                    </div>
                     
              
                     
                
             
                    
 
                   
                    <div className="col-lg-3 col-sm-6">
                        <img className="testimonial-image" src="images/dog3.JPG" alt="dog-profile"/>
                        <p className='text-white test-p p-3  '>
                        Its all about my quality time with BFF. You know, socializing, playing and being a smart pant</p>
                    </div>
               
                    <div className="col-lg-3 col-sm-6">
                        <img className="testimonial-image" src="images/jake.JPG" alt="dog-profile"/>
                        <p className='text-white p-3 test-p  '>
                       Happy playing in PmPaws dog daycare, spa, and boarding  center. I enjoy endless Love Trusted Support</p>
                    </div>
                   </div>  

            </div>
        





     
</section>



        {/* <!-- Press --> */}

        <section id="press">
            <img className="press-img" src="images/techcrunch.png" alt="tc-logo" />
            <img className="press-img" src="images/tnw.png" alt="tnw-logo" />
            <img className="press-img" src="images/bizinsider.png" alt="biz-insider-logo" />
            <img className="press-img" src="images/mashable.png" alt="mashable-logo" />

        </section>


        {/* <!-- Pricing --> */}

        <section id="pricing">

            <h2 className='h2pricing'>A Plan for Every Dog's Needs</h2>
            <p>Simple and affordable price plans for you and your dog.</p>
            <div className="row">
                <div className=" pricing-column col-lg-4 col-md-6">
                    <div className="card ">
                        <div className=" cardheader card-header">
                            <img className="imagepos " src="images/boading.jpg" alt="iphone-mockup" />
                        </div>
                        <div className=" cardbody card-body">
                        <h3 className='pricingt-text'>Boarding</h3>
                            <h3 className='pricingt-text'>$160</h3>
                            <p className='pt-lg-3'>Adequate security</p>
                            <p> Quality feeding</p>
                            <p>Free dog training book</p>
                           
                        </div>
                    </div>
                </div>
                <div className=" pricing-column col-lg-4 col-md-6">
                    <div className="card">
                    <div className=" cardheader2 card-header">
                            <img className="imagepos " src="images/spa.jpg" alt="iphone-mockup" />
                        </div>
                        <div className=" cardbody card-body">
                        <h3 className='pricingt-text'>Spa</h3>
                            <h3 className='pricingt-text'>$10</h3>
                            <p className='pt-lg-3'>breed-specific haircuts</p>
                            <p> gland expression </p>
                            <p>Sanitary trim</p>
                             
                        </div>
                    </div>
                </div>
                <div className=" pricing-column col-lg-4 col-md-12">
                    <div className="card">
                    <div className=" cardheader3 card-header">
                            <img className="imagepos " src="images/daycare.jpg" alt="iphone-mockup" />
                        </div>
                        <div className=" cardbody card-body">
                        <h3 className='pricingt-text'>Daycare</h3>
                            <h3 className='pricingt-text'>$10</h3>
                            <p className='pt-lg-3'> safe socialization</p>
                            <p>Education and training</p>
                            <p>Exercises</p>
                            
                        </div>
                    </div>

                </div>

            </div>
        </section>

        {/* 
<!-- Call to Action --> */}

        <section id="dogbooks">
            <div className="row">
                <div className=" col-md-6">
                    <div>
                        <img className="bookimg" src="images/book.JPG" alt="BOOK" />
                        <img className="bookimg2" src="images/book.JPG" alt="BOOK" />

                    </div>
                </div>
                <div className="  col-md-6">
                    <div className="blog pt-5">
                        <h5>
                        The right way to walk your dog is to
engage them properly.
Cop your copy here 
                        </h5>
                        <a href = "mailto: ispeakfordogs@yahoo.com? subject = Feedback&body = Message" className="btn btn-danger btn-lg Download"   type="button">Download</a>
                    </div>
                </div>
            </div>
        </section>


        <section id="cta-typo">
            <div className="row">
                <div className=" col-md-6">
                    <div className="typhography">
                        <h4 className='typography-text'>pawsome<sub className="text-danger">Dogs<sup className="text-green">Blog</sup><sub className="text-warning">Canine</sub> <em
                            className="text-warning">Dogs</em>BFF</sub>Care<span className="text-success">Blog<sup
                                className="text-yellow">Spa</sup></span><sub
                                    className="text-warning">Natural</sub><span>Love</span>
                            <sub className="text-danger">Fur</sub><span
                                className="text-wit">Pooch </span>  <sub
                                        className="text-purple">Topknot</sub><span className="text-yellow">Sable</span>
                            <sub><sup>Piebald</sup><span className="text-primary">Specacles</span></sub>
                            <sub>Ticked<sup>Boarding </sup>Care</sub>
                            <sup>Spa</sup><span className="text-tomred">Blog</span><span className="text-green">Natural</span>
                            <sub className="text-red">Natural</sub> <sup className="text-orange">jackass</sup>
                            <span className="text-wit"> pawsome</span> <sub className="text-yellow">Dogs<sup
                                className="text-red">Caveman<sup className="text-blue">Boarding </sup>dweeb</sup>whelp</sub>
                            <span className="text-pink">Nard</span><sub className="text-black">Dogs<sup
                                className="text-green">snoot  <sub className="text-success">Doggo</sub> <em className="text-grey"></em>BFF</sup></sub>
                            <sub className="text-primary">Care</sub><span className="text-green">Tyke</span><span
                                className="text-primary">Mane</span><span className="text-danger">Plume<sup className="text-dark">Mongrel</sup>
                            <span className="text-red">Fido</span>
                            <span className="text-warning">Tyke</span>
                            <sub className="text-dark"><sup className="text-danger"><em className="text-yellow">Dogs</em> whelp</sup></sub>snoot</span>
                            <span className="text-red">shable<sub className="text-black">Wit</sub></span><sup
                                className="text-orange">Blog</sup>BFF

                        </h4>

                    </div>
                </div>
                <div className="  col-md-6">
                    <div className=" blog">
                        <h5 className="text-secondary">
                            "From being loyal companion, to being man's best friend. Dogs provide vision to the blind, they provide movement to the ones that can't walk. Dogs provide emotional support to the traumatized. Dogs are the BEST therapist." _<i>cyber Dog Trainer</i>
                        </h5>
                        <a href="https://pmpaws.wordpress.com/" className="mt-4 btn btn-outline-secondary btn-lg " type="button">For more blog post</a>
                    </div>
                </div>
            </div>
        </section>


        {/* <!-- Footer -->  */}

        <footer id="footer">
        
       <div className='footerPositioning' >
   <a href="//posh"> <i className="social-icon fab fa-facebook-square"></i></a>
   <a href="https://twitter.com/Posh_Mo"><i className="social-icon fab fa-twitter-square"></i></a>
   <a href="https://www.instagram.com/posh_mo/"><i className="social-icon fab fa-instagram"></i></a>
  <a href = "mailto: ispeakfordogs@yahoo.com? subject = Feedback&body = Message"> <i className="social-icon fas fa-envelope-square"></i></a>
       <p>© Copyright PmPaws</p>
       </div>
   
        </footer>






    </>
        ;
}
